export const getParentsData = ({ parentList }) =>
  parentList.map(parent => {
    const parentName = parent.parent_name || '';
    const parentUid = parent.parent_document?.document?.uid || '';
    const parentType = parent.parent_document?.document?.type || '';
    const parentLang = parent.parent_document?.document?.lang || '';

    if (!parentName || !parentUid) {
      return null;
    }

    return { parentName, parentUid, parentType, parentLang };
  });
